export default "__VITE_ASSET__CPXYi$Zn__"